import styled from 'styled-components';
import { IconButton } from '@perch-labs/shrike';

export const Button = styled(IconButton)`
  border: 2px solid ${props => props.theme.colors.background.primary};
  margin: 0 8px;
  width: initial !important;

  &:focus {
    border: 2px solid ${props => props.theme.colors.content.secondary};
    box-shadow: none;
  }
`;
